import React from 'react';

const CallToAction = () => {
  return (
    <section className="bg-primary-950 py-24 px-4">
      <div className="cta-content max-w-4xl mx-auto text-center text-white">
        <h2 className="text-4xl md:text-5xl font-heading font-bold mb-6">
          Start Building with sl-address Today
        </h2>
        <p className="text-lg text-gray-300 font-body mb-10 max-w-2xl mx-auto">
          Join developers who trust sl-address for Sri Lankan address handling
        </p>

        {/* Inline code snippet */}
        <div className="inline-block bg-black/30 border border-white/10 rounded-lg px-6 py-3 mb-10">
          <code className="font-mono text-sm text-gray-300">
            npm install sl-address
          </code>
        </div>

        {/* Action buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#install"
            className="inline-flex items-center gap-2 px-8 py-3 bg-white text-primary-700 rounded-full font-semibold hover:bg-gray-100 transition-all duration-300"
          >
            Get Started
          </a>
          <a
            href="https://github.com/sumudu-k/sl-address"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3 border-2 border-white text-white rounded-full font-semibold hover:bg-white/10 transition-all duration-300"
          >
            GitHub
          </a>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
